<template>
    <transition name="fade">
      <div v-if="showModal" class="choose-base-modal">
        <div class="choose-base-modal-backdrop" @click="closeModal"></div>
        <div class="choose-base-modal-dialog">
          <div class="choose-base-modal-content">
            <div class="choose-base-modal-header">
              <h5 class="modal-title">Selecione a base a ser utilizada</h5>
              <button type="button" class="close" @click="closeModal">
                <span>&times;</span>
              </button>
            </div>
            <div class="choose-base-modal-body">
              <div class="choose-base-text-container">
                <div class="search-container">
                    <input
                      type="text"
                      v-model="searchQuery"
                      class="form-control search-input"
                      placeholder="Buscar por nome ou sigla da base..."
                    />
                </div>
                <div class="options-container">
                    <div v-for="base in filteredBases" :key="base.SiglaBase" class="option-item" @click="selectBase(base)">
                        <span class="name-info">{{ base.SiglaBase }} - {{ base.NomeBase }} </span>
                        <span v-if="!base.Status" class="badge badge-secondary">BASE INATIVA</span>
                        <span v-else-if="base.Status === 'ATIVO'" class="badge badge-success">{{ base.Status }}</span>
                        <span v-else class="badge badge-primary">{{ base.Status }}</span>
                    </div>
                    <div v-if="filteredBases.length === 0" class="no-results">
                        Nenhum resultado encontrado.
                    </div>
                </div>
              </div>
            </div>
            <div class="choose-base-modal-footer">
              <button class="cancel-button" @click="closeModal">
                <i class="fas fa-times"></i>   
                Cancelar
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: ['showModal', 'bases'],
    data() {
      return {
        selected: null,
        searchQuery: ''
      };
    },
    computed: {
    filteredBases() {
          let baseReturn;
          baseReturn = this.bases
          if (this.searchQuery){
            const query = this.searchQuery.toLowerCase();
            baseReturn = this.bases.filter(client =>
              client.NomeBase.toLowerCase().includes(query) ||
              client.SiglaBase.toString().toLowerCase().includes(query)
            );
          }

          return baseReturn.sort((a, b) => {
            if (a.Status === 'ATIVO' && b.Status !== 'ATIVO') return -1;
            if (a.Status !== 'ATIVO' && b.Status === 'ATIVO') return 1;
                    
            if (a.Status === null && b.Status !== null) return 1;
            if (a.Status !== null && b.Status === null) return -1;
                    
            return 0;
          });
        },
    },
    methods: {
        selectBase(base){
            this.$emit('base-selected', base)
        },
        closeModal(mode = 'default') {
            this.$emit('close-choose-base-modal', mode)
        },
    },
    mounted(){},
  };
  </script>
  
  <style scoped lang="scss">
  .choose-base-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1050;
  }
  
  .choose-base-modal-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
  }
  
  .choose-base-modal-dialog {
    position: relative;
    z-index: 1051;
    background: white;
    border-radius: 0.3rem;
    box-shadow: 0 3px 9px rgba(0, 0, 0, 0.5);
    width: 70vw;
    height: fit-content;
    max-width: 100%;
    overflow: hidden;
  }

  .choose-base-modal-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .choose-base-modal-header,
  .choose-base-modal-footer {
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
    font-weight: bold;
    display: flex;
    gap: 10px;

    button {
      border-radius: 7px !important;
      transition: 0.3s ease-in-out;
      border: none;
      padding: 5px 10px;
    }

    .cancel-button {
      background-color: rgb(179, 52, 52);
      color: white;

      &:hover {
        background-color: rgb(141, 42, 42);
      }
    }
  }
  
  .choose-base-modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .modal-title {
      font-weight: bold;
    }
  }
  
  .choose-base-modal-body {
    padding: 1rem;
    display: flex;
    gap: 10px;
    height: 100%;
  }

  .choose-base-text-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
    flex: 1;
    border: 2px solid lightgray;
    border-radius: 7px;
    padding: 10px;
    background-color: white;
    box-shadow: 1px 1px 6px 0px lightgray;

    textarea {
      resize: none
    }

    .options-container {
        display: flex;
        flex-direction: column;
        height: 35vh;
        overflow: auto;

        .option-item {
            display: flex;
            gap: 2px;
            border: 1px solid lightgray;
            padding: 20px 10px;
            transition: ease-in-out 0.3s;
            cursor: pointer;
            justify-content: space-between;

            &:hover {
                background-color: lightgray;
            }

            .name-info {
                font-size: small;
                font-weight: bold;
            }
        }
    }
  }
  
  .choose-base-modal-footer {
    display: flex;
    justify-content: flex-end;
  }
  
  .close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }
  
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores ao Vue 2.1.8 */ {
    opacity: 0;
  }

  .search-container {
    display: flex;
    flex-direction: column;
    gap: 5px;
    margin-bottom: 10px;

    .search-input {
      padding: 8px;
      border: 1px solid lightgray;
      border-radius: 5px;
      outline: none;
      transition: border 0.3s ease;

      &:focus {
        border-color: #007bff;
      }
    }
  }

  .no-results {
    text-align: center;
    color: gray;
    font-style: italic;
    margin-top: 10px;
  }

  .badge {
    line-height: 1.5 !important;
  }
</style>